var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAustralianRules({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DF0411",
    d: "M12.7 1.845c-1.725.018-4.118 1.116-6.32 2.88-2.586 2.07-4.426 4.655-4.783 6.981l-.013.088.176.027.014-.088C2.123 9.46 3.938 6.91 6.492 4.864c2.301-1.843 4.811-2.948 6.496-2.833.293.21.552.46.772.752 1.024 1.359.949 3.307-.002 5.211-.91.89-2.11 1.757-3.474 2.492-2.852 1.536-5.876 2.213-8.1 1.676l-.067-.017-.086-.022-.044.173.086.022c2.28.58 5.379-.104 8.295-1.675 1.191-.641 2.259-1.383 3.124-2.156-.662 1.137-1.632 2.238-2.863 3.165-3.457 2.606-7.661 2.859-9.39.565-1.727-2.293-.325-6.264 3.132-8.87 2.88-2.169 6.276-2.707 8.33-1.502z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.699,
    cy: 12.12,
    fill: "#FFF",
    rx: 1,
    ry: 1,
    transform: "rotate(32 1.7 12.12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M8.23 2.267c.456-.513 1.17-.183 2.14.847l.3.328-.32.29-.144-.16c-.886-.98-1.436-1.263-1.652-1.018-.093.104-.092.243.007.473l.078.162.076.141c.367.668.43.93.042 1.2-.29.202-.625.143-1.142-.105l-.223-.113-.38-.2c-.363-.182-.511-.226-.556-.189-.034.03.007.194.196.63l.134.307c.284.663.335 1.062-.001 1.347-.289.245-.661.215-1.235 0l-.864-.352c-.248-.093-.356-.112-.387-.085-.093.08.183.584.928 1.413l.302.329-.316.293-.147-.158C3.995 6.49 3.604 5.797 4.017 5.442c.238-.204.41-.172 1.155.142l.379.16c.516.209.815.252.954.134.112-.095.099-.306-.052-.694l-.134-.316-.131-.3c-.248-.585-.257-.765-.01-.974.24-.204.427-.175 1.012.124l.463.243c.463.239.728.305.858.215.092-.064.079-.163-.106-.512l-.15-.278-.031-.062c-.217-.436-.25-.767.007-1.057z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustralianRules);
export default __webpack_public_path__ + "static/media/australian_rules.050051d76a9034586d32e981372ad0db.svg";
export { ForwardRef as ReactComponent };